import * as React from 'react';
import { useEffect, useState } from 'react';
import userflow from 'userflow.js';
import { useCookies } from 'react-cookie';
import { OPT_OUT_GUIDED_TOURS_COOKIE } from '../NavBar/NavBar';
import { ISystemUser } from './graphql/schema/p4types';

userflow.init('ct_gdoxwvwdszhblbicd7pmkiyd2m');
userflow.setResourceCenterLauncherHidden(true);

const RESOURCE_CENTER_LAUNCHER_ICON_FONT_SIZE = {
  fontSize: '24px',
};

const RESOURCE_CENTER_LAUNCHER_COUNTER_CIRCLE_STYLES: React.CSSProperties = {
  position: 'absolute',
  top: 0,
  right: 0,
  transform: 'translate(50%, -50%)',
  background: 'red',
  color: 'white',
  borderRadius: '50%',
  padding: '2px 6px',
  fontSize: '10px',
  lineHeight: 1,
  minWidth: '16px',
  textAlign: 'center',
};

const RESOURCE_CENTER_LAUNCHER_WRAPPER_STYLES: React.CSSProperties = {
  position: 'relative',
  display: 'inline-block',
};

export const CustomResourceCenterLauncher = ({
  featureFlags,
  systemUser,
}: {
  featureFlags: Record<string, boolean>;
  systemUser: ISystemUser;
}) => {
  const [guidedToursOptOutCookie] = useCookies([OPT_OUT_GUIDED_TOURS_COOKIE]);

  useEffect(() => {
    if (systemUser && featureFlags) {
      userflow.identify(systemUser.uuid, {
        email: `${systemUser.uuid}@${systemUser.email?.split('@')[1]}`,
        admin: systemUser.admin,
        profit4Release: __VERSION__,
        ...featureFlags,
        guidedToursOptOut: guidedToursOptOutCookie[OPT_OUT_GUIDED_TOURS_COOKIE] === 'true',
      });
    }
  }, [featureFlags, systemUser, guidedToursOptOutCookie]);

  const [resourceCenterState, setResourceCenterState] = useState(() => userflow.getResourceCenterState());
  useEffect(() => {
    const onChange = () => {
      setResourceCenterState(userflow.getResourceCenterState());
    };
    userflow.on('resourceCenterChanged', onChange);
    return () => userflow.off('resourceCenterChanged', onChange);
  }, []);

  const openResouceCenter = () => {
    userflow.openResourceCenter();
  };

  return (
    <div
      onClick={openResouceCenter}
      style={RESOURCE_CENTER_LAUNCHER_WRAPPER_STYLES}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') openResouceCenter();
      }}
      role="button"
      tabIndex={0}
    >
      <i style={RESOURCE_CENTER_LAUNCHER_ICON_FONT_SIZE} className="icon">
        help_outline
      </i>
      <span style={RESOURCE_CENTER_LAUNCHER_COUNTER_CIRCLE_STYLES}>
        {resourceCenterState?.unreadAnnouncementCount ?? 0}
      </span>
    </div>
  );
};
